import React from 'react';
import './site.css';
import { Routes, Route } from 'react-router-dom';
import Nav from './components/Nav';
import Calendars from './components/Calendars';
import Contracts from './components/Contracts';
import Projections from './components/Projections';
import ImportExport from './components/ImportExport';

export default function App() {
  return (
    <div className="layout">
      <Nav />
      <main className="main">
        <Routes>
          <Route path="/" element={<div><h1>Welcome</h1><p>Select a section from the left.</p></div>} />
          <Route path="/calendars" element={<Calendars />} />
          <Route path="/contracts" element={<Contracts />} />
          <Route path="/projections" element={<Projections />} />
          <Route path="/import-export" element={<ImportExport />} />
          <Route path="*" element={<div><h1>Not Found</h1></div>} />
        </Routes>
      </main>
    </div>
  );
}
